export const sortBySessionStart = (data) => {
    if (!data)
        return [];
    const entries = Object.entries(data);
    entries.sort(([, sessionA], [, sessionB]) => {
        const dateA = new Date(sessionA.sessionStart);
        const dateB = new Date(sessionB.sessionStart);
        return dateA.getTime() - dateB.getTime();
    });
    return entries.map(([, sessionData]) => sessionData);
};
//# sourceMappingURL=sort-by-session-start.js.map